// src/utils/authGuard.js
import store from '../redux/store';
import { restoreAuthState } from '../redux';
import { LOGIN_PATH } from '../constants/uploadConfig';
import { PUBLIC_PATHS } from '../constants/authConfig';

/**
 * Restores auth state from sessionStorage and redirects to login
 * if user is unauthenticated and accessing a private route.
 * Should be called once at app startup.
 *
 * @returns {boolean} true if auth was restored, false otherwise
 */
export const initializeAuthGuard = () => {
    const authRestored = store.dispatch(restoreAuthState());
    if (!authRestored && !PUBLIC_PATHS.includes(window.location.pathname)) {
        window.location.replace(LOGIN_PATH);
    }
    return authRestored;
};